import { createRouter, createWebHashHistory } from "vue-router";
import Main from "../views/Main/mainIndex.vue";
import Login from "../views/Login/index.vue";
import Home from "../views/Home/index.vue";
import TargetData from "../views/VerificationData/TargetData.vue";
import claimTargetData from "../views/claimsVerification/compoents/TargetData.vue"
import viewDetails from "../views/VerificationData/viewDetails.vue";
// import TargetManagement from "../views/TargetManagement/index.vue";
import CustomerReportProcess from "../views/CustomerReport/views/insuranceCollection/ProcessPage.vue";
import CustomerClaimReportProcess from "../views/CustomerReport/views/claimInspection/ProcessPage.vue";
import updateClaimDetail from "../views/CustomerReport/views/updateClaimDetail/ProcessPage.vue";
import updateInsurDetail from "../views/CustomerReport/views/updateInsurDetail/ProcessPage.vue";
import { getUserInfo } from "@/views/Login/api.js";
import {getCompanyOption} from "@/views/VerificationData/api.js";
import { ElMessage } from "element-plus";
import { useStore } from 'vuex'
import { ref } from "vue";
import promisseRoute from './promisse'
import axios from 'axios';
import store from '../store';
import { decrypt } from "@/utiles/crypto";
let routerAll = [
  {
    path: "/Home",
    component: Home,
    name: "Home",
    isMenu: true,
    meta: {
      title: "首页",
      icon: "home",
    },
  },
  ...promisseRoute,
  {
    path: "/claimTargetData",
    component: claimTargetData,
    name: "claimTargetData",
    isMenu: false,
    meta: {
      title: "标的数据",
      id: '8',
      keepAlive: true
    },
  },
  {
    path: "/TargetData",
    component: TargetData,
    name: "TargetData",
    isMenu: false,
    meta: {
      title: "标的数据",
      id: '7'
    },
  },
]
const routes = [
  {
    path: "/",
    name: "main",
    component: Main,
    meta: {
      title: "路由主入口",
    },
    children: routerAll,
  },
  {
    path: "/Login",
    name: "Login",
    component: Login,
    meta: {
      title: "登录",
    },
  },
  {
    path: "/customer-report/process",
    name: "CustomerReportProcess",
    component: CustomerReportProcess,
    meta: {
      title: "上报处理",
    },
  },
  {
    path: "/customer-claim-report/process",
    name: "CustomerClaimReportProcess",
    component: CustomerClaimReportProcess,
    meta: {
      title: "理赔上报处理",
    },
  },
  {
    path: "/update-claim-detail/process",
    name: "updateClaimDetail",
    component: updateClaimDetail,
    meta: {
      title: "验标详情",
    },
  },
  {
    path: "/update-insur-detail/process",
    name: "updateInsurDetail",
    component: updateInsurDetail,
    meta: {
      title: "验标详情",
    },
  },
];
console.log('routes', routes)
const router = createRouter({
  history: createWebHashHistory(),
  routes,
});
interface TokenData {
  userId: string;
  loginName: string; // localDateTime
  token: string;
}
let ConfigBaseURL = process.env.VUE_APP_URL;
const getCompanyOptionFn = (compCode: String) => {
  if (compCode) {
    getCompanyOption(compCode)
      .then((res: any) => {
        sessionStorage.setItem("companyInfoOptions", JSON.stringify(res));
      })
      .catch((error: any) => {
        console.error("Error fetching company options:", error);
      });
  } else {
    console.log("compCode is null");
  }
};
router.beforeEach((to, from, next) => {

  if (to.name === "Home" && to.query.s) {
    const loginVo = ref<TokenData | null>(null);
    // 匹配s=后面的值，直到遇到&或字符串结束
    const match = to.fullPath.match(/s=([^&]*)/);
    const s = match ? match[1] : null;
    console.log("encoded s", s);
    console.log("s", s);
    if (s) {

      try {
        const decrypted = decrypt(s);
        console.log("解密后:", decrypted);
        if (decrypted) {
          const safeJsonString = decrypted.replace(
            /"userId":(\d+)/g,
            '"userId":"$1"'
          );
          loginVo.value = JSON.parse(safeJsonString) as TokenData;
          console.log("Token解析成功:", loginVo.value);
          // 验证时间有效性（示例：1分钟有效期）
          const isExpired = new Date(loginVo.value.loginName).getTime() + (60000*5) < Date.now()
          console.log("是否过期:",loginVo.value.loginName, new Date(loginVo.value.loginName).getTime() + 60000, Date.now(), isExpired);
          
          if (!loginVo?.value.loginName || isExpired) {
            ElMessage.error('Token已过期')
            router.push("/Login");
            // return next({ name: 'Login' })
            return
          } else {

            localStorage.setItem(`token:${loginVo.value.userId}`, loginVo.value.token);
            console.log(
              "登录成功",
              loginVo.value.userId,
              localStorage.getItem(`token:${loginVo.value.userId}`)
            );

            const userInfo = {
              id: loginVo.value.userId,
            };
            sessionStorage.setItem(`userInfo`, JSON.stringify(userInfo));

            getUserInfo(loginVo.value.token)
              .then((res: any) => {
                const loginVo = res;
                sessionStorage.setItem(`userInfo`, JSON.stringify(loginVo.sysUser));
                console.log("loginVo", loginVo);

                store.commit("SET_USERINFO", loginVo.sysUser);
                store.commit("SET_MENU", {
                  menu: loginVo.sysUser.menuList || [],
                });
                // 获取租户配置信息
                getCompanyOptionFn(loginVo.sysUser.compCode);
                store.dispatch("GetMenu");
                router.push("/Home");
              })
              .catch((err: any) => {
                console.error("获取用户信息失败:", err);
              });
          }
        }
      } catch (e) {
        console.error("Token解析失败:", e);
      }
    }
    return

  }

  if (to.name === "main") {
    router.push({
      name: "Login",
    }).then(() => {
      localStorage.clear()
      sessionStorage.clear()
    });
    return
  }
  let userInfo = sessionStorage.getItem('userInfo') ? JSON.parse(sessionStorage.getItem('userInfo') || '') : ''
  let token = localStorage.getItem(`token:${userInfo?.id}`);
  let url = sessionStorage.getItem(`url`);
  console.log("to.name",to.name);
  console.log("from.name",from.name);
  console.log("url",url);
  console.log("from.query",from.query,(from.query == null || Object.keys(from.query).length === 0));
  
  // if (url && to.name === "Login" && (from.query == null || Object.keys(from.query).length === 0)) {
  //   next(url); // 使用 next(url) 替代 router.push，确保导航完成
  //   sessionStorage.removeItem(`url`);
  //   return;
  // }

  if (to.name != "Login" && !token) {
    next({ name: "Login" });
    ElMessage({
      message: '请先登录',
      type: "error",
      duration: 3 * 1000,
    })
    return
  }
  // 将 axios 请求移到 next() 调用之前，并确保只调用一次 next()  
  axios.get(ConfigBaseURL + '/menu/auditNum', {
    headers: {
      'Token': token
    }
  })
    .then(response => {
      store.commit("SET_AUDITNUM", response.data.data); // 确保你传递的是 response.data  
      next(); // 只在请求完成后调用一次 next()  
    })
    .catch(error => {
      console.error('获取审计数字失败:', error);
      next(); // 即使请求失败，也要确保调用 next()  
    });
});
export default router;

